export interface FaqItem {
  question: string
  answer: string[]
}

export const faq: FaqItem[] = [
  {
    question: 'È un prodotto fisico o digitale?',
    answer: [
      'LOGOPEDIA PRO™ è un prodotto digitale in formato PDF ad alta qualità.',
      "Potrai scaricarlo immediatamente dopo l'acquisto e utilizzarlo da computer, tablet o smartphone.",
      'Puoi inoltre stampare i materiali che necessiti di utilizzare nella tua pratica.',
    ],
  },
  {
    question: 'È adatto a studenti o principianti?',
    answer: [
      'No.',
      'Il sistema è stato sviluppato pensando a logopedisti e professionisti del settore che possiedono già formazione ed esperienza e desiderano ridurre il tempo dedicato alla preparazione e organizzare meglio il proprio materiale di lavoro.',
      'Non è un corso introduttivo di logopedia.',
    ],
  },
  {
    question: 'Posso adattare il materiale ai miei pazienti?',
    answer: [
      'Assolutamente sì.',
      'Attività, sessioni, obiettivi, progressioni e materiali devono essere selezionati e adattati dal professionista in funzione della valutazione, delle necessità, delle capacità e della risposta individuale del paziente.',
    ],
  },
  {
    question: 'Sostituisce il giudizio professionale del logopedista?',
    answer: [
      'No.',
      "LOGOPEDIA PRO™ è uno strumento professionale di supporto alla pianificazione e all'organizzazione.",
      'La valutazione, le decisioni cliniche, la selezione degli obiettivi e l\u2019adattamento dell\u2019intervento rimangono sempre responsabilità del professionista.',
    ],
  },
  {
    question: 'Dopo quanto tempo posso iniziare a utilizzarlo?',
    answer: [
      'Immediatamente.',
      'Una volta ottenuto l\u2019accesso puoi consultare il sistema, individuare l\u2019area su cui stai lavorando e iniziare a utilizzare e adattare le risorse disponibili per le tue sessioni.',
    ],
  },
  {
    question: 'Come riceverò i 6 moduli e i 5 bonus?',
    answer: [
      'Subito dopo il pagamento riceverai una email con i link di accesso a tutti i moduli e a tutti i bonus.',
      'Il download è immediato e resta sempre disponibile: nessuna attesa e nessuna spedizione.',
    ],
  },
  {
    question: 'Il pagamento è sicuro e in quale valuta?',
    answer: [
      'Il pagamento avviene su una pagina di checkout protetta e cifrata, con carta o con i metodi disponibili nel tuo Paese.',
      'Il prezzo di 27€ viene addebitato nella tua valuta locale, senza costi aggiuntivi né abbonamenti ricorrenti.',
    ],
  },
  {
    question: 'È utile anche se lavoro con pazienti adulti?',
    answer: [
      'Sì.',
      'Valutazione, obiettivi, progressioni, monitoraggio, documentazione e revisione del caso si applicano a tutta la pratica logopedica.',
      'Le attività e i materiali vanno selezionati e adattati dal professionista in base al profilo del paziente.',
    ],
  },
  {
    question: 'Posso stampare i materiali e usarli con più pazienti?',
    answer: [
      'Sì.',
      'Puoi stampare schede, carte, esercizi e materiali per la pratica a casa e utilizzarli con i pazienti del tuo studio o del tuo centro.',
      'La licenza è personale e professionale: non è consentita la rivendita o la distribuzione a terzi.',
    ],
  },
  {
    question: 'E se non fosse adatto al mio modo di lavorare?',
    answer: [
      'Hai 14 giorni per esaminare tutto con calma.',
      'Se non è ciò che stavi cercando, ti basta scriverci e riceverai il rimborso completo. Nessun rischio e nessuna domanda.',
    ],
  },
]
